import Loadable from 'react-loadable';
import { LoadingIndicator } from 'components/common';

import 'react-dates/initialize';
import './DatePicker.scss';

export default Loadable({
  loader: () => import('react-dates' /* webpackChunkName: "react-dates" */),
  loading: () => <LoadingIndicator />,
  // eslint-disable-next-line
  render({ DayPickerSingleDateController, DayPickerRangeController }, { type, ...props }) {
    let Picker = DayPickerSingleDateController;
    type === 'range' && (Picker = DayPickerRangeController);
    return <Picker {...props} dayAriaLabelFormat="YYYY-MM-DD" />;
  },
});
